import Marquee from "react-fast-marquee";

const items = [
  "NIFTY 50",
  "BANK NIFTY",
  "PRICE ACTION",
  "OPTIONS TRADING",
  "SWING TRADING",
  "INTRADAY",
  "CANDLESTICKS",
  "BITCOIN",
  "ETHEREUM",
  "RISK MANAGEMENT",
  "TRADING PSYCHOLOGY",
  "WEALTH CREATION",
];

const TickerTape = () => {
  return (
    <div
      className="relative border-y border-border/60 bg-[hsl(var(--brand-navy))] text-white ticker-mask"
      data-testid="ticker-tape"
      aria-label="Topics ticker"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {items.concat(items).map((label, idx) => (
          <span
            key={`${label}-${idx}`}
            className="mx-6 my-4 inline-flex items-center gap-3 font-display text-sm font-semibold tracking-wider md:text-base"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--brand-orange))]" />
            {label}
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default TickerTape;
